import BSCButton from './components/BSCButton'
import BSCButtonCancel from './components/BSCButtonCancel'
import BSCButtonSelect from './components/BSCButtonSelect'
import BSCCheckbox from './components/BSCCheckbox'
import BSCCheckboxSelect from './components/BSCCheckboxSelect'
import BSCIcon from './components/BSCIcon'
import BSCInput from './components/BSCInput'
import BSCMessage from './components/BSCMessage'
import BSCModal from './components/BSCModal'
import BSCModalAction from './components/BSCModalAction'
import BSCPagination from './components/BSCPagination'
import BSCRadio from './components/BSCRadio'
import BSCSelect from './components/BSCSelect'
import BSCSteppers from './components/BSCSteppers'
import BSCSwitch from './components/BSCSwitch'
import BSCTabs from './components/BSCTabs'
import BSCTag from './components/BSCTag'
import BSCTagSelect from './components/BSCTagSelect'
import BSCToast from './components/BSCToast'
import BSCTooltip from './components/BSCTooltip'

export default {
  BSCButton,
  BSCButtonCancel,
  BSCButtonSelect,
  BSCCheckbox,
  BSCCheckboxSelect,
  BSCIcon,
  BSCInput,
  BSCMessage,
  BSCModal,
  BSCModalAction,
  BSCPagination,
  BSCRadio,
  BSCSelect,
  BSCSteppers,
  BSCSwitch,
  BSCTabs,
  BSCTag,
  BSCTagSelect,
  BSCToast,
  BSCTooltip
}
